// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2gm7W","header":"MessagesList_header__h1gr9","chat":"MessagesList_chat__NZiRz"};